import { Pipe, PipeTransform } from '@angular/core';
import { MemberSubmission } from '../../../models/submissions/member-submission';
import { SubmissionStatusIdEnum } from '../../../models/enum/shared/submission-status-id.enum';
import { EpEmployerSubmission } from '../../../models/submissions/employer-submissions/ep-employer-submission';

@Pipe({
  name: 'submissionStatusLabel'
})
export class SubmissionStatusLabelPipe implements PipeTransform {
  transform(submission: MemberSubmission | EpEmployerSubmission): string {
    switch (submission?.statusId) {
      case SubmissionStatusIdEnum.Cancelled:
        return $localize`Cancelled On`;
      case SubmissionStatusIdEnum.Completed:
        return $localize`Completed On`;
      default:
        return $localize`Last Update`;
    }
  }
}
